import { render } from "./Search.vue?vue&type=template&id=0ea6cda7"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
script.render = render

export default script